<template lang="pug">
v-container.pa-0.create-field(grid-list-md)
  v-row(align="center")
    v-col(cols="4")
      v-select(
        :value="myValue.alias",
        @change="inputMap"
        label='Map to',
        item-text="name"
        item-value="name"
        return-object,
        v-bind="{ items }",
      )
    v-col(cols="4")
      v-text-field(
        :value="myValue.name",
        label='Name',
        @change="fixFieldName"
      )
    v-col(cols="4")
      v-select(
        v-model="myValue.type",
        label="Select a Type",
        :items="filteredTypes",
        item-text="name",
        :item-value="types[0].hasOwnProperty('value') ? 'value' : 'name'",
        :disabled="!(isTab || isSection)",
      )
    v-col(cols="4", v-if="isSection")
      v-select(
        v-model="myValue.section",
        label="Select a parent Tab",
        :items="itemsSection",
        item-text="name",
        :item-value="types[0].hasOwnProperty('value') ? 'value' : 'name'",
      )
    v-col(cols="11", v-if="!(isTab || isSection)")
      v-select(
        v-model="myValue.size",
        label="Size",
        :items="sizes"
      )
    v-col(cols="1", v-if="!(isTab || isSection)")
      v-tooltip(bottom)
        template(v-slot:activator="{ on }")
          v-icon.pr-2(color="black", v-on="on") mdi-information
        img(src="../../src/assets/Help.gif" alt="Info GIF" width="300" height="250")
  template(v-if="!isTab")
    rule-controller(v-model="myValue.rules")
</template>

<script>
import RuleController from '@@/components/RuleController'

export default {
  name: 'CreateField',
  components: { RuleController },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    itemsSection: {
      type: Array,
      default: () => ([]),
    },
    types: {
      type: Array,
      default: () => ([
        {
          name: 'Text',
          value: 'String'
        },
        {
          name: 'Text',
          value: 'Guid'
        },
        {
          name: 'Check-box',
          value: 'Bool'
        },
        {
          name: 'Number',
          value: 'Int16'
        },
        {
          name: 'Number',
          value: 'Int32'
        },
        {
          name: 'Number',
          value: 'Int64'
        },
        {
          name: 'Decimal',
          value: 'Double'
        },
        {
          name: 'Date',
          value: 'DateTime'
        },
        {
          name: 'Options',
          value: 'List'
        },
        {
          name: 'Others',
          value: 'Others'
        },
      ]),
    },
    isTab: {
      type: Boolean,
      default: false,
    },
    isSection: {
      type: Boolean,
      default: false,
    },
    replaceWhiteSpaces: {
      type: Boolean,
      default: true,
    }
  },
  data () {
    return {
      showRules: false,
      myValue: this.value,
      sizes: [],
      filteredTypes: [],
    }
  },
  watch: {
    value (val) {
      this.myValue = val
    },
    myValue (val) {
      this.$emit('input', val)
    },
  },
  methods: {
    fixFieldName(val) {
      this.myValue.name = (val !== null && this.replaceWhiteSpaces) ? val.replace(/\s/g, '_') : val
    },
    inputMap(val) {
      this.myValue = {...this.myValue, ...val, rules: [], alias: val.name, type: (val.type || val.name)};
      this.filteredTypes = this.filterTypes();
    },
    filterTypes() {
      if(!(this.isTab || this.isSection) || !this.myValue || !this.myValue.alias) return this.types;
      return this.types.filter(x => ((x.alias === this.myValue.type)) || x.name === this.myValue.type);
    },
  },
  created () {
    for (let s = 12; s--;) {
      this.sizes.push(s + 1)
    }
    this.sizes.reverse()
  }
}
</script>
